export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00782.a2de3c5e.png";